import React from "react";
import { useMediaQuery } from "react-responsive";

function CompanyDetail({
  scrollToSection,
  homeRef,
  featureRef,
  benefitRef,
  contactRef,
  workRef,
}) {
  const isLaptop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });

  return (
    <div
      className={`${isTablet ? "column gap-2" : "gap-1"} flex `}
      style={{ width: isLaptop ? "" : "85%", margin: "auto" }}
    >
      <div data-aos="fade-right">
        <img
          src="/images/auction-image.png"
          alt="logo"
          className="auction-landing-img"
          style={{ height: "60px" }}
        />
        <p
          className={`${isSmallLaptop ? "font-14px" : "font-20px"} grey-text`}
          style={{ lineHeight: isSmallLaptop ? "18px" : "28px" }}
        >
          Join Cercle X to participate in competitive e-auctions for scrap
          materials. Maximize returns and ensure secure, transparent
          transactions.
        </p>
      </div>
      <div data-aos="fade-left" style={{ minWidth: isLaptop ? "60%" : "55%" }}>
        {/* <h4 className="grey-text">PAGES</h4> */}
        <div className="valign-wrapper space-between mt-1 contactDetails flex-wrap">
          <p onClick={() => scrollToSection(homeRef)}>Home</p>
          <p onClick={() => scrollToSection(featureRef)}>Features</p>
          <p onClick={() => scrollToSection(benefitRef)}>Benefits</p>
          <p onClick={() => scrollToSection(workRef)}>How it works</p>
          <p onClick={() => scrollToSection(contactRef)}>Contact us</p>
        </div>
        <div className="valign-wrapper space-between mt-2 contactDetail-media flex-wrap gap-1">
          <p>
            <span className="material-icons-outlined font-30px cercle-purple-text">
              location_on
            </span>
            AIC RAISE Business Incubator
          </p>
          <p>
            <span className="material-icons-outlined font-30px cercle-purple-text">
              email
            </span>
            auction@cerclex.com
          </p>
          <p>
            <span className="material-icons-outlined font-30px cercle-purple-text">
              call
            </span>
            +91 8807416965
          </p>
        </div>
        <div></div>
      </div>
    </div>
  );
}

export default CompanyDetail;
